import { Site } from './../../../api';
import { isNil, isString } from './../../../utils';
import { li, lw } from './../../services/logger/logger.service';
import { bootstrapPutSite, BootstrapSource } from './../../utils/bootstrap.utils';
import { SiteBootstrapDirective } from './site.bootstrap.directive';

/* Copyright IBM Corp. 2017 */
const LOGGER = 'SiteBootstrap';

/*
 * site decorator
 *
 * @Annotation
 */
export function SiteBootstrap(aDirective?: SiteBootstrapDirective):
    (target: any, propertyKey: string) => void {
    // test if we have a siteId
    const siteId = aDirective ? aDirective.siteId : undefined;
    // export the decorator function
    return function (target: any, propertyKey: string): void {

        // access the property, probably lazily
        function _accessProperty(): BootstrapSource<Site> {
            // access the prop
            const result = target[propertyKey] as BootstrapSource<Site>;
            if (isNil(result)) {
                // log this
                lw(LOGGER, 'Accessing', propertyKey, 'from', target, 'returned nothing. Was this intended?');
            } else {
                li(LOGGER, 'Accessing', propertyKey, 'from', target);
            }
            // ok
            return result;
        }

        // register access to this property
        if (isString(siteId)) {
            // add a generator
            bootstrapPutSite(_accessProperty, siteId);
        } else {
            // resolve immediately
            bootstrapPutSite(_accessProperty());
        }
    };
}
